// Formatacao de moeda do produto.
//
// Cada componente carregava seu proprio `R$ ${...toLocaleString('pt-BR')}`:
// numa conta que vende em outra moeda, todo valor aparecia com o simbolo
// errado — e o produto atende mais de uma empresa. Aqui a moeda vem da conta
// (predominante nos deals, via o preambulo /modules) e o Intl cuida do
// simbolo, da posicao e da abreviacao.
import { ref } from 'vue';

const currency = ref('BRL');
const locale = ref('pt-BR');

export const setReportCurrency = (code, localeCode) => {
  if (code) currency.value = code;
  if (localeCode) locale.value = localeCode;
};

export const accountCurrency = currency;
export const reportCurrency = currency; // alias historico

const format = (value, options = {}) =>
  new Intl.NumberFormat(locale.value, {
    style: 'currency',
    currency: options.currency || currency.value,
    ...options,
  }).format(Number(value) || 0);

// Para registros que carregam a propria moeda (deal, contrato, custo de
// anuncio importado): usa a do registro e cai na da conta quando ausente.
export const moneyFor = (value, code) =>
  format(value, {
    currency: code || currency.value,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Valor curto para cartao/eixo: "R$ 7 mil", "US$ 1,2 mi".
export const money = (value, digits = 1) => {
  const n = Number(value) || 0;
  if (Math.abs(n) >= 1000) {
    return format(n, { notation: 'compact', maximumFractionDigits: digits });
  }
  return format(n, { maximumFractionDigits: 0 });
};

// Valor cheio para tabela e detalhe: "R$ 6.951,68".
export const moneyFull = value =>
  format(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Só o símbolo, para rótulos do tipo "R$/lead".
export const currencySymbol = () =>
  format(0, { maximumFractionDigits: 0 })
    .replace(/[\d\s.,]/g, '')
    .trim();
